module.exports = __webpack_public_path__ + "static/media/twitter.2c6197bf.svg";